import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=907a85c8&scoped=true&"
import script from "./error-404.vue?vue&type=script&lang=js&"
export * from "./error-404.vue?vue&type=script&lang=js&"
import style0 from "./error-404.vue?vue&type=style&index=0&id=907a85c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907a85c8",
  null
  
)

export default component.exports